import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap } from 'rxjs/operators';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { PricingRuleAction } from '../pricingRule.action';

type IDependencies = IClientApiDependencySegment;

export const exportPricingRulesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingRuleAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportPricingRules().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          PricingRuleAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
